import {useState, useContext} from "react";
import AuthContext from "context/AuthContext";
import {useTranslation} from "react-i18next";
import LoginOTPSetupApp from "./LoginOTPSetupApp";
import LoginOTPSetupEmail from "./LoginOTPSetupEmail";

const LoginOTPSetup = () => {
    const {completeSetupLogin} = useContext(AuthContext);
    const {t: _Ta} = useTranslation("authenticate");
    const [selectedType, setSelectedType] = useState(null);

    if (selectedType === "app") return <LoginOTPSetupApp />;
    if (selectedType === "email") return <LoginOTPSetupEmail />;

    return (
        <div className="form-signin w-100 m-auto">
            <h1 className="h5 mb-3 fw-normal text-center">{_Ta("title.otp-choose")}</h1>
            <p className="mb-4 text-center">{_Ta("title.otp-choose-desc")}</p>
            <button className="btn btn-primary w-100 mb-3" onClick={() => setSelectedType("app")}>
                {_Ta("buttons.otp-type-app")}
            </button>
            <button className="btn btn-outline-primary w-100 mb-3" onClick={() => setSelectedType("email")}>
                {_Ta("buttons.otp-type-email")}
            </button>
            <button className="btn btn-link w-100 text-muted" onClick={completeSetupLogin}>
                {_Ta("buttons.otp-skip")}
            </button>
        </div>
    );
};
export default LoginOTPSetup;

